import { c as _c } from "react/compiler-runtime";
import { patchHostedUserVaultMutation } from '@onefootprint/fetch-hosted';
import type { FieldError } from '@onefootprint/hooks';
import type { VaultData } from '@onefootprint/request-types';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { CollectCardData } from '@/idv2/features/collect-card-data';
import { useFootprint } from '@/idv2/hooks/use-footprint';
import { useVaultMutationError } from '@/idv2/hooks/use-vault-mutation-error';
import { getLogger } from '@/idv2/utils/logger';
const {
  logInfo,
  logWarn,
  logError
} = getLogger({
  name: 'idv2',
  location: 'collect-card-data-route'
});
export const Route = createFileRoute('/onboarding/$token/collect-card-data')({
  component: CollectCardDataPage,
  loader: async ({
    context: {
      currentRequirement
    }
  }) => {
    if (currentRequirement?.kind !== 'collect_card_data') {
      throw new Error(`Invalid requirement kind: ${currentRequirement?.kind ?? 'undefined'}`);
    }
    logInfo('Collect card data loader started', {
      requirementKind: currentRequirement.kind,
      cardAlias: currentRequirement.cardAlias
    });
    return {
      currentRequirement
    };
  }
});
export function CollectCardDataPage() {
  const $ = _c(11);
  const {
    currentRequirement
  } = Route.useLoaderData();
  const {
    token
  } = Route.useParams();
  const footprint = useFootprint();
  const {
    l10n
  } = Route.useRouteContext();
  const handleVaultError = useVaultMutationError();
  let t0;
  if ($[0] !== token) {
    t0 = patchHostedUserVaultMutation({
      headers: {
        "X-Fp-Authorization": token
      }
    });
    $[0] = token;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    mutateAsync: vaultMutation,
    isPending
  } = useMutation(t0);
  let t1;
  if ($[2] !== footprint || $[3] !== handleVaultError || $[4] !== vaultMutation) {
    t1 = async (data, onError) => {
      logInfo("Collect card data form submission started", {
        vaultKeys: Object.keys(data).join(",")
      });
      ;
      try {
        await vaultMutation({
          body: data
        });
        logInfo("Collect card data vault mutation succeeded");
        footprint.navigation.forward();
      } catch (t2) {
        const error = t2;
        const fieldErrors = handleVaultError(error, onError);
        const log = fieldErrors.length > 0 ? logWarn : logError;
        log("Collect card data vault mutation failed", error, {
          fieldErrorCount: fieldErrors.length
        });
      }
    };
    $[2] = footprint;
    $[3] = handleVaultError;
    $[4] = vaultMutation;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onSubmit = t1;
  let t2;
  if ($[6] !== currentRequirement || $[7] !== isPending || $[8] !== l10n || $[9] !== onSubmit) {
    t2 = <CollectCardData l10n={l10n} isLoading={isPending} onSubmit={onSubmit} currentRequirement={currentRequirement} />;
    $[6] = currentRequirement;
    $[7] = isPending;
    $[8] = l10n;
    $[9] = onSubmit;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}